const store = require("store");

const isLoggedIn = () => {
    return store.get("access_token") !== undefined && store.get("grade_code") !== undefined
}

export default isLoggedIn;
